import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Container, Grid, makeStyles } from '@material-ui/core';

import Page from 'src/components/Page';
import { Toast } from 'src/components/Toast/Toast';

import { Alert, AlertTitle } from '@material-ui/lab';

import { getUserById, putUser, deleteUser } from 'src/services/users';

import UsuarioFormDetails from './UsuarioDetail';

import UserContext from '../../../context/UserContext';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Comision = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [usuario, setUsuario] = useState([]);

  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');
  const [severity, setSeverity] = useState('success');

  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const getUser = async () => {
    if (id !== '0') {
      const { data } = await getUserById(id, user.token);
      setUsuario(data);
    }
  };

  const updateUser = async values => {
    await putUser(values, user.token);
  };
  
  const deleteUsuario = async idUser => {
    await deleteUser(idUser, user.token);
  };

  useEffect(() => {
    getUser();
  }, []);

  return (
    <Page className={classes.root} title="Comisión">
      <Toast
        open={showToast}
        title={
          <Alert severity={severity}>
            {<AlertTitle>{title}</AlertTitle>}
            {message}
          </Alert>
        }
        handleClose={() => setShowToast(false)}
        duration={2000}
      />
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <UsuarioFormDetails
              usuario={usuario}
              updateUsuario={updateUser}
              deleteUsuario={deleteUsuario}
              create={() => {}}
              setLoading={setLoading}
              setTitleSnack={setTitle}
              setShowToast={setShowToast}
              setMessage={setMessage}
              setSeverity={setSeverity}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Comision;
